import Layout from "components/Layout"
import PrivateRoute from "components/PrivateRoute"
import PropTypes from "prop-types"
import compose from "ramda/src/compose"
import React, { useEffect } from "react"
import { Route, Switch, withRouter } from "react-router-dom"
import AlgarForever from "scenes/AlgarForever"
import DataTrafficDetails from "scenes/DataTraffic/DataTrafficDetails"
import DetailingPosPreControle from "scenes/DetailingPosPreControle"
import IncidentManager from "scenes/IncidentManager"
import Login from "scenes/Login"
import InterfaceOnline from "scenes/NewInterfaceOnline"
import TrafficPreControle from "scenes/TrafficPreControle"
import ENV from "./envProperties"
import ConsumptionProfile from "./scenes/ConsumptionProfile"
import DataQuota from "./scenes/DataQuota"
import ClientDetails from "./scenes/FixedVoice/Pages/ClientDetails"
import ConfirmScreen from "./scenes/FixedVoice/Pages/ConfirmScreen"
import FixedVoice from "./scenes/FixedVoice/Pages/Dashboard"
import ExpertAnalysis from "./scenes/FixedVoice/Pages/ExpertAnalysis"
import MySpecialistRequests from "./scenes/FixedVoice/Pages/MySpecialistRequests"
import NewSale from "./scenes/FixedVoice/Pages/NewSale"
import RechargeDocuments from "./scenes/RechargeDocuments"
import Schedule from "./scenes/Schedule"
import SharedData from "./scenes/SharedData"
import ShareEnergy from "./scenes/SharedEnergy"

const Root = ({ location: { pathname: path } }) => {
  const RedirectToNewPortal = () => {
    useEffect(() => {
      window.location.replace(`${ENV.URL_NEW_B2B}/v1/auth/login`)
    }, [])

    return null
  }

  const RedirectToLocalHome = () => {
    return null
  }

  if (path.startsWith("/login")) {
    return <Login />
  }

  if (path.startsWith("/callback")) {
    const params = new URLSearchParams(window.location.search)
    return (
      <Login
        isAuthenticationStep
        code={params.get("code")}
        state={params.get("state")}
        redirectUri={window.location.href}
      />
    )
  }

  if (path.startsWith("/logoff")) {
    return <Login logOff={true} />
  }

  return (
    <PrivateRoute
      path="/"
      render={() => (
        <Layout path={path} type="v1">
          <Switch>
            <Route path="/" exact component={RedirectToNewPortal} />
            <Route path="/inicio" exact component={RedirectToLocalHome} />
            <Route path="/interface-online" component={InterfaceOnline} />
            <Route
              path="/detailing-pos-pre-controle"
              component={DetailingPosPreControle}
            />
            <Route
              path="/traffic-pre-controle"
              component={TrafficPreControle}
            />
            <Route path="/fixed-voice" component={FixedVoice} exact />
            <Route
              path="/fixed-voice/client-details"
              component={ClientDetails}
            />
            <Route path="/fixed-voice/new-sale" component={NewSale} />
            <Route
              path="/fixed-voice/confirm-screen"
              component={ConfirmScreen}
            />
            <Route
              path="/fixed-voice/specialist-requests"
              component={MySpecialistRequests}
            />
            <Route
              path="/fixed-voice/specialist-analysis"
              component={ExpertAnalysis}
            />
            <Route path="/data-traffic/:id" component={DataTrafficDetails} />
            <Route path="/data-traffic" component={DataQuota} />
            <Route path="/incident-manager" component={IncidentManager} />
            <Route path="/algar-forever" component={AlgarForever} />
            <Route
              path="/schedule/:id"
              render={(routeProps) => (
                <Schedule {...this.props} {...routeProps} />
              )}
            />
            <Route path="/consumption-profile" component={ConsumptionProfile} />
            <Route path="/shared-data" component={SharedData} />
            <Route path="/recharge-documents" component={RechargeDocuments} />
            <Route path="/share-energy" component={ShareEnergy} />
          </Switch>
        </Layout>
      )}
    />
  )
}

Root.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    startsWith: PropTypes.func
  })
}

const enhance = compose(
  // FIX: https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/blocked-updates.md
  withRouter
)

export default enhance(Root)



// WEBPACK FOOTER //
// ./src/Root.js